import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ExcerptPipe } from "./excerpt.pipe";
import { GetValueByKeyPipe } from "./get-value-by-key.pipe";
import { RelativeTimePipe, DataNotificacaoPTPipe } from "./relative-time.pipe";
import { CpfCNPJPipe } from "./cpfcpnj.pipe";
import { NumberToWordsPipe } from "./number-to-words.pipe";

const pipes = [
  ExcerptPipe,
  GetValueByKeyPipe,
  RelativeTimePipe,
  CpfCNPJPipe,
  DataNotificacaoPTPipe,
  NumberToWordsPipe
];

@NgModule({
  imports: [CommonModule],
  declarations: pipes,
  exports: pipes,
})
export class SharedPipesModule { }
